(() => {
  'use strict';
  if (customElements.get('k2-photo-gallery')) return;
  class K2PhotoGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready || !window.HTMLDialogElement) return;
      this.ready = true;
      this.photos = JSON.parse(this.querySelector('[data-photos]').textContent);
      this.dialog = this.querySelector('dialog');
      this.image = this.querySelector('[data-gallery-image]');
      this.caption = this.querySelector('[data-gallery-caption]');
      this.count = this.querySelector('[data-gallery-count]');
      this.querySelectorAll('[data-photo-index]').forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        this.opener = link;
        this.show(Number(link.dataset.photoIndex));
        this.dialog.showModal();
      }));
      this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.opener?.focus());
    }
    show(index) {
      this.index = (index + this.photos.length) % this.photos.length;
      const photo = this.photos[this.index];
      this.image.src = photo.url;
      this.image.alt = photo.caption;
      this.caption.textContent = photo.caption;
      this.count.textContent = `${this.index + 1} / ${this.photos.length}`;
    }
  }
  customElements.define('k2-photo-gallery', K2PhotoGallery);
  class K2SitePlan extends HTMLElement {
    connectedCallback() {
      if (this.ready || !window.HTMLDialogElement) return;
      this.ready = true;
      const link = this.querySelector('[data-plan-open]');
      const dialog = this.querySelector('dialog');
      link.addEventListener('click', event => { event.preventDefault(); dialog.showModal(); });
      this.querySelector('[data-plan-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => link.focus());
    }
  }
  customElements.define('k2-site-plan', K2SitePlan);
})();
